import {FC, ReactNode} from 'react'
import {useFormContext} from 'react-hook-form'
import {Body, BodyItems, BodyErrors, ComplementText, Header, Row} from './AdditionalSearchField'
import {DateField} from '../reactHookForm/DateField'
import styles from './DateRow.scss'

interface DateRowProps {
  header: ReactNode
  startName: string
  endName: string
}

export const DateRow: FC<DateRowProps> = ({header, startName, endName}) => {
  const {getFieldState} = useFormContext()
  const startError = getFieldState(startName).error?.message
  const endError = getFieldState(endName).error?.message

  return (
    <Row>
      <Header>{header}</Header>
      <Body>
        <BodyItems>
          <div className={styles.dateField}>
            <DateField name={startName} displayJpDate={false} small shouldUnregister />
          </div>
          <ComplementText>から</ComplementText>
          <div className={styles.dateField}>
            <DateField name={endName} displayJpDate={false} small shouldUnregister />
          </div>
          <ComplementText>の間</ComplementText>
        </BodyItems>
        <BodyErrors>
          {startError && <p className={styles.error}>{startError}</p>}
          {endError && <p className={styles.error}>{endError}</p>}
        </BodyErrors>
      </Body>
    </Row>
  )
}
